"use strict";

function iterate(min, max, interval) {
  var skip = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var quantities = [];

  for (var i = min; i <= max; i += interval) {
    if (!skip.includes(i)) {
      quantities.push({
        key: i,
        value: i,
        text: String(i)
      });
    }
  }

  return quantities;
}
/**
 *
 * @param {*} params
 * @param {String} params.comonent_name - if present, function will retrieve opts from ShineProducts
 * @param {Number} params.min
 * @param {Number} params.max
 * @param {Number} params.interval
 * @param {Array<Number>} params.skip
 */


function generateQuantityOptions(_ref) {
  var min = _ref.min,
      max = _ref.max,
      interval = _ref.interval,
      skip = _ref.skip;
  return iterate(min, max, interval, skip);
}

module.exports = generateQuantityOptions;